<template>
  <li class="headline">
    {{ t('menu.tabs.setup') }}
  </li>
  <li @click="grimoire.newGame">
    {{ t('menu.newGame') }}
    <em><font-awesome-icon icon="hand-sparkles" class="fa fa-hand-sparkles" /></em>
  </li>
  <li v-if="players.length < 20" @click="playersStore.addPlayer()">
    {{ t('menu.addPlayer') }}<em>[A]</em>
  </li>
  <li v-if="players.length < 19" @click="playersStore.addPlayers()">
    {{ t('menu.addPlayers') }}<em>[P]</em>
  </li>
  <li v-if="voiceChat.town?.name" @click="playersStore.createSeats()">
    {{ t('menu.createSeats') }}<em><font-awesome-icon :icon="['fab', 'discord']" class="fab fab-discord" /></em>
  </li>
  <li v-if="players.length > 2" @click="playersStore.randomize()">
    {{ t('menu.randomizeSeats') }}
    <em><font-awesome-icon icon="dice" class="fa fa-dice" /></em>
  </li>
  <li v-if="players.length" @click="playersStore.clearPlayers">
    {{ t('menu.removeSeats') }}
    <em><font-awesome-icon icon="trash-alt" class="fa fa-trash-alt" /></em>
  </li>
  <li v-if="grimoire.isTextChatAllowed" @click="chatStore.clearMessages(false)">
    {{ t('menu.clearChat') }}
    <em><font-awesome-icon icon="trash-alt" class="fa fa-trash-alt" /></em>
  </li>
  <li v-if="players.length" @click="playersStore.clearRoles(false)">
    {{ t('menu.clearRoles') }}
    <em><font-awesome-icon icon="trash-alt" class="fa fa-trash-alt" /></em>
  </li>
  <li v-if="!session.isPlayerOrSpectator" @click="grimoire.toggleModal('edition')">
    {{ t('menu.selectEdition') }}
    <em>[E]</em>
  </li>
  <li v-if="!session.isPlayerOrSpectator" @click="grimoire.toggleModal('fabled')">
    {{ t('menu.addFabled') }}
    <em><font-awesome-icon icon="dragon" class="fa fa-dragon" /></em>
  </li>
  <li v-if="!session.isPlayerOrSpectator && players.length > 4" @click="grimoire.toggleModal('roles')">
    {{ t('menu.assign') }}
    <em>[C]</em>
  </li>
  <li v-if="!session.isPlayerOrSpectator" @click="playersStore.distributeRolesAction()">
    {{ t('menu.sendRoles') }}
    <em><font-awesome-icon icon="theater-masks" class="fa fa-theater-masks" /></em>
  </li>
</template>

<script setup lang="ts">
import {
  useChatStore,
  useGrimoireStore,
  useLocaleStore,
  usePlayersStore,
  useSessionStore,
  useVoiceChatStore,
} from "@/stores";
import { computed } from "vue";

const chatStore = useChatStore();
const grimoire = useGrimoireStore();
const locale = useLocaleStore();
const t = locale.t;
const playersStore = usePlayersStore();
const session = useSessionStore();
const voiceChat = useVoiceChatStore();

const players = computed(() => playersStore.players);
</script>

<style lang="scss" src="./Menu.scss" scoped></style>
